export const DremioServiceName = 'Dremio';
export const DremioServiceSymbol = Symbol.for(DremioServiceName);
